import React, { RefObject } from 'react';
import styled from 'styled-components';
import { getFunName } from '../helpers';

const SInputWithButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SInput = styled.input`
  text-align: center;
  width: 40vw;
  height: 4vh;
  margin-bottom: 2em;
`;

interface IPollPickerInputProps {
  startPoll(event: React.FormEvent<Element>): void;
  inputPollName: RefObject<any>;
}

export default class PollPickerInput extends React.Component<
  IPollPickerInputProps
> {
  funName: string = getFunName();

  state: any = {
    inputValue: this.funName
  };

  normalizePollName = (pollName: string) => {
    const regex = /\s/gi;
    return pollName.replace(regex, '-').toLowerCase();
  };

  handleChange = (event: any) => {
    event.preventDefault();
    const normalizedPollName = this.normalizePollName(event.target.value);
    this.setState({ inputValue: normalizedPollName });
  };

  handleFocus = (event: any) => {
    event.preventDefault();
    if (event.target.value === this.funName) {
      this.setState({ inputValue: '' });
    }
  };

  handleBlur = (event: any) => {
    event.preventDefault();
    if (event.target.value === '') {
      this.setState({ inputValue: this.funName });
    }
  };

  render() {
    const { inputPollName } = this.props;

    return (
      <SInputWithButton>
        <SInput
          type='text'
          ref={inputPollName}
          value={this.state.inputValue}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          required
        />
        <button type='submit'>Create Poll!</button>
      </SInputWithButton>
    );
  }
}
